import React, { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useNavigate } from 'react-router-dom';
import './Survey.css';
// Firestore 匯入
import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';

// 國家與城市資料
const countryCityData = {
  Taiwan: [
    "台北市", "新北市", "基隆市", "桃園市", "新竹市", "新竹縣", "苗栗縣", "台中市", "彰化縣", "南投縣", "雲林縣", "嘉義市", "嘉義縣", "台南市", "高雄市", "屏東縣", "宜蘭縣", "花蓮縣", "台東縣", "澎湖縣", "金門縣", "連江縣", "其他"
  ],
  China: [
    "北京", "上海", "廣州", "深圳", "重慶", "天津", "成都", "杭州", "蘇州", "南京", "武漢", "西安", "青島", "大連", "長春", "瀋陽", "哈爾濱", "福州", "廈門", "鄭州", "長沙", "昆明", "貴陽", "南寧", "香港", "澳門", "其他"
  ],
  Japan: [
    "東京", "大阪", "京都", "橫濱", "名古屋", "札幌", "福岡", "神戶", "川崎", "埼玉", "千葉", "廣島", "仙台", "北九州", "其他"
  ],
  Korea: [
    "首爾", "釜山", "仁川", "大邱", "大田", "光州", "蔚山", "水原", "昌原", "高陽", "其他"
  ],
  USA: [
    "New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Jose", "Austin", "Jacksonville", "San Francisco", "Columbus", "Fort Worth", "其他"
  ],
  Canada: [
    "Toronto", "Montreal", "Vancouver", "Calgary", "Edmonton", "Ottawa", "Winnipeg", "Quebec City", "Hamilton", "Kitchener", "其他"
  ],
  UK: [
    "London", "Birmingham", "Manchester", "Glasgow", "Liverpool", "Leeds", "Sheffield", "Edinburgh", "Bristol", "Cardiff", "其他"
  ],
  Australia: [
    "Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Canberra", "Newcastle", "Wollongong", "其他"
  ],
  Germany: [
    "Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt", "Stuttgart", "Dusseldorf", "Dortmund", "Essen", "Leipzig", "其他"
  ],
  France: [
    "Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille", "其他"
  ],
  Italy: [
    "Rome", "Milan", "Naples", "Turin", "Palermo", "Genoa", "Bologna", "Florence", "Bari", "Catania", "其他"
  ],
  Spain: [
    "Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Malaga", "Murcia", "Palma", "Las Palmas", "Bilbao", "其他"
  ],
  Singapore: ["Singapore", "其他"],
  Malaysia: [
    "Kuala Lumpur", "George Town", "Ipoh", "Shah Alam", "Petaling Jaya", "Johor Bahru", "Malacca", "Kota Kinabalu", "其他"
  ],
  Thailand: [
    "Bangkok", "Nonthaburi", "Nakhon Ratchasima", "Chiang Mai", "Hat Yai", "Udon Thani", "Pak Kret", "Khon Kaen", "其他"
  ],
  Vietnam: [
    "Ho Chi Minh City", "Hanoi", "Hai Phong", "Can Tho", "Da Nang", "Bien Hoa", "Nha Trang", "Hue", "其他"
  ],
  Indonesia: [
    "Jakarta", "Surabaya", "Bandung", "Medan", "Bekasi", "Depok", "Semarang", "Palembang", "Tangerang", "其他"
  ],
  Philippines: [
    "Quezon City", "Manila", "Davao City", "Caloocan", "Cebu City", "Zamboanga City", "Taguig", "Antipolo", "Pasig", "其他"
  ],
  Other: ["主要城市", "其他"]
};

function Survey() {
  const [age, setAge] = useState('');
  const [city, setCity] = useState({ country: '', city: '', custom: '' });
  const [hasMoldIssue, setHasMoldIssue] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');


  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!age && !city.country && !hasMoldIssue && !name && !phone) {
      alert('請至少填寫一項資料再送出！');
      return;
    }
    if (!executeRecaptcha) {
      alert('reCAPTCHA 尚未載入，請稍後再試');
      return;
    }
    const recaptchaToken = await executeRecaptcha('survey_submit');
    if (!recaptchaToken) {
      alert('reCAPTCHA 驗證失敗，請重試');
      return;
    }
    const data = {
      age,
      country: city.country,
      city: city.city,
      customCity: city.custom,
      hasMoldIssue,
      name,
      phone,
      createdAt: new Date().toISOString(),
      recaptchaToken
    };
    try {
      await addDoc(collection(db, 'survey'), data);
      navigate('/main');
    } catch (error) {
      alert('資料儲存失敗：' + error.message);
    }
  };

  return (
    <div className="survey-container">
      <h1 className="survey-title">讓我們更了解怎麼幫助您！</h1>

      <form onSubmit={handleSubmit}>
        <div className="question-block">
          <h2>
            <span className="diamond">◆</span> 年齡範圍：（下拉式）
          </h2>
          <div className="options-row">
            <label>
              <input
                type="radio"
                name="age"
                value="11歲以下"
                checked={age === '11歲以下'}
                onChange={(e) => setAge(e.target.value)}
              />
              11歲以下
            </label>
            <label>
              <input
                type="radio"
                name="age"
                value="12-17歲"
                checked={age === '12-17歲'}
                onChange={(e) => setAge(e.target.value)}
              />
              12-17歲
            </label>
            <label>
              <input
                type="radio"
                name="age"
                value="18-24歲"
                checked={age === '18-24歲'}
                onChange={(e) => setAge(e.target.value)}
              />
              18-24歲
            </label>
            <label>
              <input
                type="radio"
                name="age"
                value="25-34歲"
                checked={age === '25-34歲'}
                onChange={(e) => setAge(e.target.value)}
              />
              25-34歲
            </label>
            <label>
              <input
                type="radio"
                name="age"
                value="35-44歲"
                checked={age === '35-44歲'}
                onChange={(e) => setAge(e.target.value)}
              />
              35-44歲
            </label>
            <label>
              <input
                type="radio"
                name="age"
                value="45歲以上"
                checked={age === '45歲以上'}
                onChange={(e) => setAge(e.target.value)}
              />
              45歲以上
            </label>
          </div>
        </div>

        <div className="question-block">
          <h2>
            <span className="diamond">◆</span> 所在城市 / 地區：
          </h2>
          <div className="location-selects">
            <select
              value={city.country || ""}
              onChange={(e) => {
                const selectedCountry = e.target.value;
                setCity({ country: selectedCountry, city: '', custom: '' });
              }}
              className="country-select"
            >
              <option value="">請選擇國家/地區</option>
              {Object.keys(countryCityData).map((country) => (
                <option key={country} value={country}>{country === 'Other' ? '其他' : country}</option>
              ))}
            </select>
            {city.country && (
              <>
                <select
                  value={city.city || ""}
                  onChange={(e) => setCity(prev => ({ ...prev, city: e.target.value, custom: '' }))}
                  className="city-select"
                >
                  <option value="">請選擇城市</option>
                  {countryCityData[city.country].map(cityName => (
                    <option key={cityName} value={cityName}>{cityName}</option>
                  ))}
                </select>
                {city.city === '其他' && (
                  <input
                    type="text"
                    className="city-select"
                    style={{ marginTop: 8 }}
                    placeholder="請輸入城市名稱"
                    value={city.custom}
                    onChange={e => setCity(prev => ({ ...prev, custom: e.target.value }))}
                  />
                )}
              </>
            )}
          </div>
        </div>

        <div className="question-block">
          <h2>
            <span className="diamond">◆</span> 家中是否曾出現黴菌問題？（點選）
          </h2>
          <div className="options-row">
            <label>
              <input
                type="radio"
                name="moldIssue"
                value="是"
                checked={hasMoldIssue === '是'}
                onChange={(e) => setHasMoldIssue(e.target.value)}
              />
              是
            </label>
            <label>
              <input
                type="radio"
                name="moldIssue"
                value="否"
                checked={hasMoldIssue === '否'}
                onChange={(e) => setHasMoldIssue(e.target.value)}
              />
              否
            </label>
          </div>
        </div>

        <div className="contact-info">
          <div className="contact-fields">
            <div className="field-group">
              <label>姓名：</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="field-group">
              <label>電話：</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
          </div>


          <div className="btn-group">
  <button
    type="submit"
    style={{
      background: 'rgba(154, 71, 61, 0.97)',
      color: 'white',
      border: 'none',
      padding: '16px 32px',
      borderRadius: 8,
      fontSize: '1.5rem',
      fontWeight: 700,
      cursor: 'pointer'
    }}
  >送出</button>
  <button
    type="button"
    style={{
      background: '#eee',
      color: '#444',
      border: 'none',
      padding: '16px 32px',
      borderRadius: 8,
      fontSize: '1.5rem',
      fontWeight: 700,
      cursor: 'pointer'
    }}
    onClick={() => navigate('/main')}
  >略過</button>
</div>
        </div>
      </form>
    </div>
  );
}

export default Survey;
